function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }
  
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  
    if(summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }
  
    summary.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
  
    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  });
  
  const trapFocusHandlers = {};
  
  function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];
  
    removeTrapFocus();
  
    trapFocusHandlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      )
        return;
  
      document.addEventListener('keydown', trapFocusHandlers.keydown);
    };
  
    trapFocusHandlers.focusout = function() {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };
  
    trapFocusHandlers.keydown = function(event) {
      if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
      // On the last focusable element and tab forward, focus the first element.
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
  
      //  On the first focusable element and tab backward, focus the last element.
      if (
        (event.target === container || event.target === first) &&
        event.shiftKey
      ) {
        event.preventDefault();
        last.focus();
      }
    };
  
    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);
  
    elementToFocus.focus();
  
    if (elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  }
  
  // Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
  try {
    document.querySelector(":focus-visible");
  } catch(e) {
    focusVisiblePolyfill();
  }
  
  function focusVisiblePolyfill() {
    const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
    let currentFocusedElement = null;
    let mouseClick = null;
  
    window.addEventListener('keydown', (event) => {
      if(navKeys.includes(event.code.toUpperCase())) {
        mouseClick = false;
      }
    });
  
    window.addEventListener('mousedown', (event) => {
      mouseClick = true;
    });
  
    window.addEventListener('focus', () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
  
      if (mouseClick) return;
  
      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
  
    }, true);
  }
  
  function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }
  
  function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  
    if (elementToFocus) elementToFocus.focus();
  }
  
  function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
  
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
  
    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
  }
  
class QuantityInput extends HTMLElement 
{
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('keyup', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
    this.RunInputChange( );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    this.validateQtyRules( );
    RunCartQuantityChange( this, event.target.name, this.input.value );
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      // buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }

  // NOTE : this only works for ONE TIME PURCHASES !
  RunInputChange( )
  {
      var form = this.input.form;
      var formVariant;
      var element;
      
      if ( form )
      {
          element = form;
          formVariant = form.querySelector( ".product-variant-id" ).value;
      }
      else
      {
          element = this.closest( "quantity-input" );
          formVariant = element.getAttribute( "data-variant-id" );
      }

      if ( formVariant )
      {
          var cartInputs = document.querySelectorAll( ".cart-drawer-items-container .we_cart_item[ data-variant-id='"+ formVariant +"' ] input[type='number']" );
          if ( cartInputs )
          {
              for ( var i = 0; i < cartInputs.length; i++ )
              {
                  var cartInput = cartInputs[ i ];
                  var item      = cartInput.closest( ".we_cart_item" );
                  var spid      = item.getAttribute( "data-selling-plan-id" );
                  //console.log( "got spid " + spid  + " from ", item );
                  if ( spid )
                  {
                      // currently ignoring subscription items in the cart
                  }
                  else
                  {
                      //console.log( "set qty " + this.input.value + " on ", cartInput );
                      cartInput.value = this.input.value;
                      var event = new Event( "keyup" );
                      cartInput.dispatchEvent( event );
                      break;
                  }
              }
          }
      }
      else
      {
          console.log( "error - unsupported qty selector dom" );
      }
  }
}

function RunCartQuantityChange( item, qtyType, qtyInputValue )
{
    //console.log( "cart qty change for ", item );
    
    //nasty !
    var form = item.input.form;
    var formVariant;
    var element;
    
    if ( form )
    {
        element = form;
        formVariant = form.querySelector( ".product-variant-id" ).value;
    }
    else
    {
        element = item.closest( "quantity-input" );
        formVariant = element.getAttribute( "data-variant-id" );
    }

    if ( formVariant )
    {
        var cartQtyButton = document.querySelector( ".cart-drawer-items-container .we_cart_item[ data-variant-id='"+ formVariant +"' ]:not([data-selling-plan-id]) .cart-quantity-value-change[data-type='" + qtyType + "']" );

        //console.log( "disable cart qty control ", element );
        // element.setAttribute( "disabled", "disabled" );
        // element.classList.add( "disabled" );
        
        cartQtyButton.click();

        

        // 20241209: disabling this, new handling in custom.js is more reliable
        //if( qtyInputValue == "1" && qtyType == "minus" )
        //{
        //    console.log( "run decrement" );
        //    HandleFormButtonDisplay( form, "hide" );
        //}
        //else if( qtyInputValue == 1 && qtyType == "plus" )
        //{
        //    console.log( "run increment" );
        //    HandleFormButtonDisplay( form, "show" );
        //}
    }
    else
    {
        console.log( "error - unsupported qty selector dom" );
    }
}
  
  customElements.define('quantity-input', QuantityInput);
  
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  
  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }
  
  /*
   * Shopify Common JS
   *
   */
  if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
  }
  
  Shopify.bind = function(fn, scope) {
    return function() {
      return fn.apply(scope, arguments);
    }
  };
  
  Shopify.setSelectorByValue = function(selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
      var option = selector.options[i];
      if (value == option.value || value == option.innerHTML) {
        selector.selectedIndex = i;
        return i;
      }
    }
  };
  
  Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
  };
  
  Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};
  
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
  
    for(var key in params) {
      var hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", key);
      hiddenField.setAttribute("value", params[key]);
      form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };
  
  Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
    this.countryEl         = document.getElementById(country_domid);
    this.provinceEl        = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  
    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));
  
    this.initCountry();
    this.initProvince();
  };
  
  Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
      var value = this.countryEl.getAttribute('data-default');
      Shopify.setSelectorByValue(this.countryEl, value);
      this.countryHandler();
    },
  
    initProvince: function() {
      var value = this.provinceEl.getAttribute('data-default');
      if (value && this.provinceEl.options.length > 0) {
        Shopify.setSelectorByValue(this.provinceEl, value);
      }
    },
  
    countryHandler: function(e) {
      var opt       = this.countryEl.options[this.countryEl.selectedIndex];
      var raw       = opt.getAttribute('data-provinces');
      var provinces = JSON.parse(raw);
  
      this.clearOptions(this.provinceEl);
      if (provinces && provinces.length == 0) {
        this.provinceContainer.style.display = 'none';
      } else {
        for (var i = 0; i < provinces.length; i++) {
          var opt = document.createElement('option');
          opt.value = provinces[i][0];
          opt.innerHTML = provinces[i][1];
          this.provinceEl.appendChild(opt);
        }
  
        this.provinceContainer.style.display = "";
      }
    },
  
    clearOptions: function(selector) {
      while (selector.firstChild) {
        selector.removeChild(selector.firstChild);
      }
    },
  
    setOptions: function(selector, values) {
      for (var i = 0, count = values.length; i < values.length; i++) {
        var opt = document.createElement('option');
        opt.value = values[i];
        opt.innerHTML = values[i];
        selector.appendChild(opt);
      }
    }
  };
  
  class MenuDrawer extends HTMLElement {
    constructor() {
      super();
  
      this.mainDetailsToggle = this.querySelector('details');
  
      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.bindEvents();
    }
  
    bindEvents() {
      this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
  
    onKeyUp(event) {
      if(event.code.toUpperCase() !== 'ESCAPE') return;
  
      const openDetailsElement = event.target.closest('details[open]');
      if(!openDetailsElement) return;
  
      openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }
  
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.has-submenu');
      const isOpen = detailsElement.hasAttribute('open');
      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  
      function addTrapFocus() {
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
        summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
      }
  
      if (detailsElement === this.mainDetailsToggle) {
        if(isOpen) event.preventDefault();
        isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
  
        if (window.matchMedia('(max-width: 990px)')) {
          document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
        }
      } else {
        setTimeout(() => {
          detailsElement.classList.add('menu-opening');
          summaryElement.setAttribute('aria-expanded', true);
          parentMenuElement && parentMenuElement.classList.add('submenu-open');
          !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }, 100);
      }
    }
  
    openMenuDrawer(summaryElement) {
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
  
    closeMenuDrawer(event, elementToFocus = false) {
      if (event === undefined) return;
  
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
        submenu.classList.remove('submenu-open');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  
    onFocusOut() {
      setTimeout(() => {
        if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
      });
    }
  
    onCloseButtonClick(event) {
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
  
    closeSubmenu(detailsElement) {
      const parentMenuElement = detailsElement.closest('.submenu-open');
      parentMenuElement && parentMenuElement.classList.remove('submenu-open');
      detailsElement.classList.remove('menu-opening');
      detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
      removeTrapFocus(detailsElement.querySelector('summary'));
      this.closeAnimation(detailsElement);
    }
  
    closeAnimation(detailsElement) {
      let animationStart;
  
      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }
  
        const elapsedTime = time - animationStart;
  
        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
          if (detailsElement.closest('details[open]')) {
            trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
          }
        }
      }
  
      window.requestAnimationFrame(handleAnimation);
    }
  }
  
  customElements.define('menu-drawer', MenuDrawer);
  
  class HeaderDrawer extends MenuDrawer {
    constructor() {
      super();
    }
  
    openMenuDrawer(summaryElement) {
      this.header = this.header || document.querySelector('.section-header');
      this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
      document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
      this.header.classList.add('menu-open');
  
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
  
      summaryElement.setAttribute('aria-expanded', true);
      window.addEventListener('resize', this.onResize);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
  
    closeMenuDrawer(event, elementToFocus) {
      if (!elementToFocus) return;
      super.closeMenuDrawer(event, elementToFocus);
      this.header.classList.remove('menu-open');
      window.removeEventListener('resize', this.onResize);
    }
  
    onResize = () => {
      this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    };
  }
  
  customElements.define('header-drawer', HeaderDrawer);
  
  class ModalDialog extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        'click',
        this.hide.bind(this, false)
      );
      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
      if (this.classList.contains('media-modal')) {
        this.addEventListener('pointerup', (event) => {
          if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
        });
      } else {
        this.addEventListener('click', (event) => {
          if (event.target === this) this.hide();
        });
      }
    }
  
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }
  
    show(opener) {
      this.openedBy = opener;
      const popup = this.querySelector('.template-popup');
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
      if (popup) popup.loadContent();
      trapFocus(this, this.querySelector('[role="dialog"]'));
      window.pauseAllMedia();
    }
  
    hide() {
      document.body.classList.remove('overflow-hidden');
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
      this.removeAttribute('open');
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia();
    }
  }
  customElements.define('modal-dialog', ModalDialog);
  
  class ModalOpener extends HTMLElement {
    constructor() {
      super();
  
      const button = this.querySelector('button');
  
      if (!button) return;
      button.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(button);
      });
    }
  }
  customElements.define('modal-opener', ModalOpener);
  
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener('click', this.loadContent.bind(this));
    }
  
    loadContent(focus = true) {
      window.pauseAllMedia();
      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
  
        this.setAttribute('loaded', true);
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus) deferredElement.focus();
        if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
          // force autoplay for safari
          deferredElement.play();
        }
      }
    }
  }
  
  customElements.define('deferred-media', DeferredMedia);
  
  class SliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.enableSliderLooping = false;
      this.currentPageElement = this.querySelector('.slider-counter--current');
      this.pageTotalElement = this.querySelector('.slider-counter--total');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
  
      if (!this.slider || !this.nextButton) return;
  
      this.initPages();
      const resizeObserver = new ResizeObserver(entries => this.initPages());
      resizeObserver.observe(this.slider);
  
      this.slider.addEventListener('scroll', this.update.bind(this));
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }
  
    initPages() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      this.update();
    }
  
    resetPages() {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.initPages();
    }
  
    update() {
      // Temporarily prevents unneeded updates resulting from variant changes
      // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
      if (!this.slider || !this.nextButton) return;
  
      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
  
      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.totalPages;
      }
  
      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }}));
      }
  
      if (this.enableSliderLooping) return;
  
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
  
      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
  
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }
  
    onButtonClick(event) {
      event.preventDefault();
      const step = event.currentTarget.dataset.step || 1;
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  }
  
  customElements.define('slider-component', SliderComponent);
  
  class SlideshowComponent extends SliderComponent {
    constructor() {
      super();
      this.sliderControlWrapper = this.querySelector('.slider-buttons');
      this.enableSliderLooping = true;
  
      if (!this.sliderControlWrapper) return;
  
      this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
      if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
  
      this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
      this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
      this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
      this.setSlideVisibility();
  
      if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    }
  
    setAutoPlay() {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.autoplaySpeed = this.slider.dataset.speed * 1000;
  
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.addEventListener('mouseover', this.focusInHandling.bind(this));
      this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
      this.addEventListener('focusin', this.focusInHandling.bind(this));
      this.addEventListener('focusout', this.focusOutHandling.bind(this));
  
      this.play();
      this.autoplayButtonIsSetToPlay = true;
    }
  
    onButtonClick(event) {
      super.onButtonClick(event);
      const isFirstSlide = this.currentPage === 1;
      const isLastSlide = this.currentPage === this.sliderItemsToShow.length;
  
      if (!isFirstSlide && !isLastSlide) return;
  
      if (isFirstSlide && event.currentTarget.name === 'previous') {
        this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
      } else if (isLastSlide && event.currentTarget.name === 'next') {
        this.slideScrollPosition = 0;
      }
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  
    update() {
      super.update();
      this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
      this.prevButton.removeAttribute('disabled');
  
      if (!this.sliderControlButtons.length) return;
  
      this.sliderControlButtons.forEach(link => {
        link.classList.remove('slider-counter__link--active');
        link.removeAttribute('aria-current');
      });
      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }
  
    autoPlayToggle() {
      this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
      this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
      this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }
  
    focusOutHandling(event) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    }
  
    focusInHandling(event) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    }
  
    play() {
      this.slider.setAttribute('aria-live', 'off');
      clearInterval(this.autoplay);
      this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }
  
    pause() {
      this.slider.setAttribute('aria-live', 'polite');
      clearInterval(this.autoplay);
    }
  
    togglePlayButtonState(pauseAutoplay) {
      if (pauseAutoplay) {
        this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
      } else {
        this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
      }
    }
  
    autoRotateSlides() {
      const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  
    setSlideVisibility() {
      this.sliderItemsToShow.forEach((item, index) => {
        const linkElements = item.querySelectorAll('a');
        if (index === this.currentPage - 1) {
          if (linkElements.length) linkElements.forEach(button => {
            button.removeAttribute('tabindex');
          });
          item.setAttribute('aria-hidden', 'false');
          item.removeAttribute('tabindex');
        } else {
          if (linkElements.length) linkElements.forEach(button => {
            button.setAttribute('tabindex', '-1');
          });
          item.setAttribute('aria-hidden', 'true');
          item.setAttribute('tabindex', '-1');
        }
      });
    }
  
    linkToSlide(event) {
      event.preventDefault();
      const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  }
  
  customElements.define('slideshow-component', SlideshowComponent);
  
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);
    }
  
    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantStatuses();
  
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
      document.querySelector( "product-info" ).dataset.variantUrl = document.querySelector( "variant-radios input:checked" ).dataset.variantUrl;
      document.querySelector( "product-info" ).dataset.variantPrice = document.querySelector( "variant-radios input:checked" ).dataset.variantPrice;
    }
  
    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }
  
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }
  
    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
  
      const activeMedia = this.currentVariant.featured_media.id;
      document.querySelector( `.product-media-main-item.is-active` )?.classList.remove( "is-active" );
      document.querySelector( `.product-media-main-item[data-media-id="${this.dataset.section}-${activeMedia}"]` )?.classList.add( "is-active" );

      var productMediaMain = document.querySelector('.product-media-main');
      if ( productMediaMain.classList.contains( "slick-initialized" ) )
      {
        productMediaMain.slick.slickGoTo( document.querySelector( `.product-media-main-item[data-media-id="${this.dataset.section}-${activeMedia}"]` ).dataset.slickIndex );
      }
    }
  
    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton || !shareButton.updateUrl) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  
    updateVariantStatuses() {
      const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
      const inputWrappers = [...this.querySelectorAll('.product-form__input')];
      inputWrappers.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
        this.setInputAvailability(optionInputs, availableOptionInputsValue)
      });
    }
  
    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach(input => {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.innerText = input.getAttribute('value');
        } else {
          input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
        }
      });
    }
  
    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('pickup-availability');
      if (!pickUpAvailability) return;
  
      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }
  
    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;
  
      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }
  
    renderProductInfo() {
      const requestedVariantId = this.currentVariant.id;
      const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
  
      fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          // prevent unnecessary ui changes from abandoned selections
          if (this.currentVariant.id !== requestedVariantId) return;
  
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const priceDestination = document.getElementById(`price-${this.dataset.section}`);
          const priceSource = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
          const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
  
          if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;
          if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
          if (skuSource && skuDestination) {
            skuDestination.innerHTML = skuSource.innerHTML;
            skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
          }
  
          if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');
  
          const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
          this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);
  
          publish(PUB_SUB_EVENTS.variantChange, {data: {
            sectionId,
            html,
            variant: this.currentVariant
          }});
        });
    }
  
    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;
  
      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }
  
      if (!modifyClass) return;
    }
  
    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
      const sku = document.getElementById(`Sku-${this.dataset.section}`);
  
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add('visibility-hidden');
      if (inventory) inventory.classList.add('visibility-hidden');
      if (sku) sku.classList.add('visibility-hidden');
    }
  
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  
  customElements.define('variant-selects', VariantSelects);
  
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }
  
    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach(input => {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.classList.remove('disabled');
        } else {
          input.classList.add('disabled');
        }
      });
    }
  
    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }
  
  customElements.define('variant-radios', VariantRadios);
  
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
  
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
  
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
  
            if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
              this.remove();
            }
  
            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
  
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
    }
  }
  
  customElements.define('product-recommendations', ProductRecommendations);

class CustomDatePicker extends HTMLElement
{
    constructor( )
    {
        super( );
    }

    connectedCallback( )
    {
        //bindings
        this.toggleCalendar = this.toggleCalendar.bind( this );
        this.goToPreviousMonth = this.goToPreviousMonth.bind( this );
        this.goToNextMonth = this.goToNextMonth.bind( this );
        this.selectDay = this.selectDay.bind( this );

        //elements
        this.modal = this.querySelector( ".js-cdp-modal" );
        this.toggles = this.querySelectorAll( ".js-cdp-toggle" );
        this.prevMonthBtn = this.querySelector( ".js-cdp-month-prev" );
        this.nextMonthBtn = this.querySelector( ".js-cdp-month-next" );
        this.monthText = this.querySelector( ".js-cdp-month" );
        this.rows = this.querySelector( ".js-cdp-rows" );
        this.rowTemplate = this.querySelector( ".js-cdp-row--template" );
        this.dayTemplate = this.querySelector( ".js-cdp-day--template" );

        //variables
        this.today = new Date( );
        this.shownMonth = new Date( );
        this.selectedDate = new Date( );
        this.tempSelected = new Date( );
        this.days =
        [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday"
        ]
        this.months =
        [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];
        this.options =
        {
            weekday: "long"
        };
        this.formatter = new Intl.DateTimeFormat("en-US", this.options );
        this.dayValue = 60 * 60 * 26;

        //eventlisteners
        this.toggles.forEach( toggle =>
        {
            toggle.addEventListener( "click", this.toggleCalendar );
        });

        this.prevMonthBtn.addEventListener( "click", this.goToPreviousMonth );
        this.nextMonthBtn.addEventListener( "click", this.goToNextMonth );

        this.renderMonthView( this.shownMonth.getMonth( ), this.shownMonth.getFullYear( ) );

        //console.log( this.today );
    }

    toggleCalendar( )
    {
        if ( this.modal.classList.contains( "cdp__modal--active" ) )
        {
            this.modal.classList.remove( "cdp__modal--active" );
            this.modal.ariaExpanded = false;
        }
        else
        {
            this.modal.classList.add( "cdp__modal--active" );
            this.modal.ariaExpanded = true;
        }
    }

    goToPreviousMonth( )
    {
        this.shownMonth.setMonth( this.shownMonth.getMonth( ) - 1 );
        this.renderMonthView( this.shownMonth.getMonth( ), this.shownMonth.getFullYear( ) );
    }

    goToNextMonth( )
    {
        this.shownMonth.setMonth( this.shownMonth.getMonth( ) + 1 );
        this.renderMonthView( this.shownMonth.getMonth( ), this.shownMonth.getFullYear( ) );
    }

    renderMonthView( month, year )
    {
        var oldRows = document.querySelectorAll( ".js-cdp-row" );
        oldRows.forEach( row =>
        {
            row.remove( );
        })

        var daysInMonth = new Date( year, month + 1, 0 ).getDate( );
        var firstOfMonth = new Date( year, month, 1 );
        var lastOfMonth = new Date( year, month + 1, 0 );
        
        var daysToAddBefore = this.days.indexOf( this.formatter.format( firstOfMonth ) );
        var daysToRender = [ ];
        for ( var i = 0; i < daysToAddBefore; i ++ )
        {
            var offset = daysToAddBefore - i;
            var tempDate = new Date( firstOfMonth );
            tempDate.setDate( tempDate.getDate( ) - offset );
            daysToRender.push( { day: tempDate.getDate( ), month: tempDate.getMonth( ), year: tempDate.getFullYear( ) } );
        }

        for ( var i = 0; i < daysInMonth; i ++ )
        {
            var day = i + 1;
            daysToRender.push( { day: day, month: firstOfMonth.getMonth( ), year: firstOfMonth.getFullYear( ) } );
        }

        var remainingDaysToAdd = 7 - ( daysToRender.length % 7 );
        if ( remainingDaysToAdd == 7 )
        {
            remainingDaysToAdd = 0;
        }

        for ( var i = 0; i < remainingDaysToAdd; i ++ )
        {
            var offset = i + 1;
            var tempDate = new Date( lastOfMonth );
            tempDate.setDate( tempDate.getDate( ) + offset );
            daysToRender.push( { day: tempDate.getDate( ), month: tempDate.getMonth( ), year: tempDate.getFullYear( ) } );
        }

        daysToRender.forEach( ( day, index ) =>
        {
            var dayElement = this.dayTemplate.cloneNode( );
            var rowElement = this.rowTemplate.cloneNode( false );

            var rowNumber = Math.floor( index / 7 ) + 1;
            
            var rows = this.rows.querySelectorAll( ".js-cdp-row" );
            if ( rows.length < rowNumber )
            {
                rowElement.classList.remove( "js-cdp-row--template" )
                rowElement.classList.remove( "calendar__picker__row--template" );
                rowElement.classList.add( "js-cdp-row" )
                this.rows.appendChild( rowElement );
                rows = this.rows.querySelectorAll( ".js-cdp-row" );
            }

            var rowToInsertIn = rows[ rowNumber - 1 ];
            dayElement.classList.remove( "js-cdp-day--template" );
            dayElement.classList.add( "js-cdp-day" );

            if ( firstOfMonth.getMonth() != day.month )
            {
                dayElement.classList.add( "row__day--oob" );
                dayElement.disabled = true;
            }
            if ( this.today.getMonth( ) == day.month && this.today.getDate( ) == day.day && this.today.getFullYear( ) == day.year )
            {
                dayElement.classList.add( "row__day--today" );
            }

            dayElement.textContent = day.day;
            rowToInsertIn.appendChild( dayElement );
        });

        this.monthText.textContent = `${ this.months[ firstOfMonth.getMonth( ) ] } ${ firstOfMonth.getFullYear( ) }`;
    }

    setDayEventListeners( )
    {
        var days = this.querySelectorAll( ".js-cdp-day" );
        days.addEventListener( "click", this.selectDay );
    }

    selectDay( )
    {
        //to be added,
    }
}

customElements.define( "custom-date-picker", CustomDatePicker );

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// moved from inline script in component-product-quantity.liquid
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// document.addEventListener('DOMContentLoaded', function () 
// {
//     var quantityInputs = document.querySelectorAll('quantity-input');

//     // to do : what if it takes longer than 500ms to change the product quantity ? FIXME !!
//     quantityInputs.forEach(wrapper => 
//     {
//         var plusBtn = wrapper.querySelector('button[name="plus"]');
//         var minusBtn = wrapper.querySelector('button[name="minus"]');

//         var disableButtonsTemporarily = () => 
//         {
//             plusBtn.disabled = true;
//             minusBtn.disabled = true;
//             setTimeout(() => 
//             {
//                 plusBtn.disabled = false;
//                 minusBtn.disabled = false;
//             }, 500);
//         };

//         plusBtn.addEventListener('click', disableButtonsTemporarily);
//         minusBtn.addEventListener('click', disableButtonsTemporarily);
//     });
// });
  


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// autoship banner
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function StartAutoshipBannerHandling( )
{
    function SetupAutoShipEvents( )
    {
        var buttons = document.querySelectorAll( ".autoship-banner-close" );
        buttons.forEach( function( button )
        {
            button.addEventListener( "click", function( e )
            {
                var popup = e.currentTarget.closest( ".autoship-banner" );
                if ( popup )
                {
                    popup.classList.add( "hidden" );
                }
            } );
        } );
    }

    window.addEventListener( "load", SetupAutoShipEvents );
}
StartAutoshipBannerHandling( );

function handleCustomLoyaltyContent( )
{
	var customContent = document.querySelector( "[data-custom-loyaly-content]" );
	var loyaltyContainer = document.querySelector( "[data-lion-integrated-page]" );

	if ( customContent && loyaltyContainer )
	{
		var headerTries = 0;
		var headerInterval = setInterval(function() 
		{
			headerTries ++;
			if ( loyaltyContainer.querySelector( ".lion-header__your-points" ) )
			{
				clearInterval( headerInterval );

        var points = customContent.querySelector(".custom-loyalty__point").textContent;
        points = points.replace(/[^\d]/g, "");
        points = parseInt(points, 10) || 0; 
        var pointsMoney = formatter.format(parseFloat(points / 100));
				var newHeader = customContent.querySelector( ".custom-loyalty__header" );
				newHeader.querySelector( ".text__cash-amount" ).textContent = pointsMoney;
				loyaltyContainer.querySelector( ".lion-header" ).insertAdjacentElement( "beforebegin", newHeader );
				loyaltyContainer.querySelector( ".lion-header__your-points" ).classList.add( "hidden" );
				loyaltyContainer.querySelector( ".lion-header__pending-points" ).classList.add( "hidden" );
			}
			else if ( faqsTries == 20 )
			{
				clearInterval( headerInterval );
			}
		}, 250 );

		var faqsTries = 0;
		var faqsInterval = setInterval(function() 
		{
			faqsTries ++;
			if ( loyaltyContainer.querySelector( ".lion-integrated-page" ) )
			{
				clearInterval( faqsInterval );
				var faqs = customContent.querySelector( ".custom-loyalty__faqs" );
				if ( loyaltyContainer.querySelector( ".lion-available-rewards" ) )
				{
					loyaltyContainer.querySelector( ".lion-available-rewards" ).insertAdjacentElement( "beforebegin", faqs );
				}
				else if ( loyaltyContainer.querySelector( ".lion-earn" ) )
				{
					loyaltyContainer.querySelector( ".lion-earn" ).insertAdjacentElement( "beforebegin", faqs );
				}
			}
			else if ( faqsTries == 20 )
			{
				clearInterval( checkInterval );
			}
		}, 250 );
	}
}

function initSecondaryNav( )
{
    var nav = document.querySelector( ".secondary-navigation-section" );
    if ( nav )
    {
        document.addEventListener( "scroll", function( )
        {
            if ( window.scrollY > 0 && window.innerWidth > 968 )
            {
                nav.classList.add( "secondary-navigation-section--fixed" );
            }
            else
            {
                nav.classList.remove( "secondary-navigation-section--fixed" );
            }
        });
    }
}

function initAutoshipNextOrderWidgets( )
{
	function widgetsCB( )
	{
		var widgets = document.querySelectorAll( ".next-autoship-order-widget-wrapper" );
		if ( rechargeData && rechargeData.charges && rechargeData.charges.length > 0 )
		{
			console.log( "Found charge" );

			var newestCharge = getNextRechargeCharge( rechargeData );

			widgets.forEach( widget =>
			{
				console.log( "Found widget" );

				var qty = 0;
				newestCharge.lines.forEach( line =>
				{
					qty += line.qty;
					
				});

				var qtyString;
				if ( qty == 1 )
				{
					qtyString = "1 item";
				}
				else if ( qty > 1 )
				{
					qtyString = qty + " items";
				}

				const chargeDate = new Date( newestCharge.at );
				const options = { weekday: 'long', month: 'long', day: 'numeric' };
				const formatted = new Intl.DateTimeFormat( 'en-US', options ).format( chargeDate );

				widget.querySelector( ".order__date" ).textContent = formatted;
				var count = parseInt(qtyString, 10) || 0;
        widget.querySelector(".naow__upper__count").textContent = (count - 1) + " items";

				widget.querySelector( ".u1" ).classList.remove( "hidden" );
				widget.querySelector( ".u2" ).classList.add( "hidden" );
			});
		}
	};

	console.log( "Initialising Autoship Widgets..." );

	var rechargeData;

	if ( window._autoshipData )
	{
		var rechargeData = window._autoshipData;
		widgetsCB( );
	}
	else 
    {
		console.log( "fetching" )
        FetchNextAutoshipOrder( function ( err, response )
        {
			window._autoshipData = response;
            rechargeData = response;
			widgetsCB( );
        });
    }
}

function wecEnsureNoFlickerStyle()
{
    if (document.getElementById('wec-noflicker-style'))
    {
        return;
    }
    var styleEl = document.createElement('style');
    styleEl.id = 'wec-noflicker-style';
    styleEl.textContent = '.js-wec-populate:not(.wec-ready){visibility:hidden}';
    document.head.appendChild(styleEl);
}

function wecHidePlaceholders()
{
    var nodes = document.querySelectorAll('.js-wec-populate');
    for (let i = 0; i < nodes.length; i++)
    {
        var node = nodes[i];
        node.classList.remove('wec-ready');
        if (!node.hasAttribute('data-wec-tpl'))
        {
            node.setAttribute('data-wec-tpl', node.innerHTML);
        }
    }
}

function wecFormatMoneyFromPoints(points)
{
    if (typeof formatter !== 'undefined')
    {
        return formatter.format(points / 100);
    }
    if (window.Shopify && typeof Shopify.formatMoney === 'function')
    {
        return Shopify.formatMoney(points);
    }
    var val = (points / 100).toFixed(2);
    return '£' + val;
}

function wecStopPoll()
{
    var id = document.documentElement.dataset.wecPollId;
    if (id)
    {
        window.clearInterval(Number(id));
        delete document.documentElement.dataset.wecPollId;
    }
}

function wecStartPoll()
{
    wecStopPoll();
    let attempts = 0;
    var pollId = window.setInterval(function poll()
    {
        attempts = attempts + 1;
        var el = document.querySelector('.js-lion-points-amount');
        var text = '';
        if (el)
        {
            text = el.textContent.trim();
        }
        if (text.length === 0)
        {
            if (attempts > 60)
            {
                wecStopPoll();
            }
        }
        else
        {
            wecStopPoll();
            wecHydrate(text);
        }
    }, 250);
    document.documentElement.dataset.wecPollId = String(pollId);
}

function wecInitPlaceholdersOnce()
{
    if (document.documentElement.dataset.wecInitialized === '1')
    {
        return;
    }
    wecEnsureNoFlickerStyle();
    wecHidePlaceholders();
    document.documentElement.dataset.wecInitialized = '1';
}

function wecPointsChanged(newPoints)
{
    var last = document.documentElement.dataset.wecLastPoints;
    if (String(newPoints) === String(last))
    {
        return false;
    }
    document.documentElement.dataset.wecLastPoints = String(newPoints);
    return true;
}

function wecHydrate(rawText)
{
    var pointsText = rawText.replace(/[^\d]/g, '');
    var points = parseInt(pointsText, 10);
    if (isNaN(points))
    {
        points = 0;
    }
    if (!wecPointsChanged(points))
    {
        var already = document.querySelectorAll('.js-wec-populate');
        for (let k = 0; k < already.length; k++)
        {
            already[k].classList.add('wec-ready');
        }
        return;
    }
    var money = wecFormatMoneyFromPoints(points);
    var nodes = document.querySelectorAll('.js-wec-populate');
    for (let i = 0; i < nodes.length; i++)
    {
        var node = nodes[i];
        var tpl = node.getAttribute('data-wec-tpl') || node.innerHTML;
        var html = tpl.replace(/%points%/g, String(points)).replace(/%money%/g, String(money));
        node.innerHTML = html;
    }
    window.requestAnimationFrame(function reveal()
    {
        var toReveal = document.querySelectorAll('.js-wec-populate');
        for (let j = 0; j < toReveal.length; j++)
        {
            toReveal[j].classList.add('wec-ready');
        }
    });
    var guests = document.querySelectorAll('.welleasy-cash-widget.guest');
    var logged = document.querySelectorAll('.welleasy-cash-widget.logged-in');
    for (let g = 0; g < guests.length; g++)
    {
        guests[g].classList.add('hidden');
    }
    for (let l = 0; l < logged.length; l++)
    {
        logged[l].classList.remove('hidden');
    }
}

function populateWellEasyCash()
{
    wecInitPlaceholdersOnce();
    wecStartPoll();
}

function initWelleasyCashNoFlicker()
{
    wecInitPlaceholdersOnce();
    if (document.readyState === 'loading')
    {
        document.addEventListener('DOMContentLoaded', populateWellEasyCash);
    }
    else
    {
        populateWellEasyCash();
    }
    let wecCartDebounce;
    document.addEventListener('cart_item_added', function onCartItemAdded()
    {
        window.clearTimeout(wecCartDebounce);
        wecCartDebounce = window.setTimeout(function runPoll()
        {
            wecStartPoll();
        }, 100);
    });
}

function flipWECWidgetLink()
{
    var loggedInWidgets = document.querySelectorAll('.welleasy-cash-widget.guest');
    loggedInWidgets.forEach(function handleWidget(widget)
    {
        if (widget.scrollWidth > widget.offsetWidth)
        {
            widget.querySelector('.wcw__upper__link').classList.remove('visibility-hidden');
            widget.querySelector('.wcw__lower__link').classList.add('visibility-hidden');
        }
        else
        {
            widget.querySelector('.wcw__upper__link').classList.add('visibility-hidden');
            widget.querySelector('.wcw__lower__link').classList.remove('visibility-hidden');
        }
    });
}

window.addEventListener( "resize", flipWECWidgetLink );

function SetupManageOrderLink()
{
    var link    = document.querySelector(".manage-order-link");
    var modal   = document.querySelector(".autoship-manager");
    var closeBtn = document.querySelector(".autoship-manager-close");

    if (!link || !modal || !closeBtn)
    {
        return;
    }

    link.addEventListener("click", function(e)
    {
        e.preventDefault();
        modal.classList.add("autoship-manager--visible");
        closeBtn.classList.add("autoship-manager-close--visible");
    });
}

function SetupOrdersListScrollFix()
{
    var lists = document.querySelectorAll(
        ".cpo__orders-list__orders, .order__items"
    );

    if ( !lists || lists.length === 0 )
    {
        return;
    }

    lists.forEach( function( el )
    {
        el.addEventListener(
            "wheel",
            function( e )
            {
                var scrollable = e.target.closest(
                    ".cpo__order-details, .cpo__order, .order__items"
                );

                if ( scrollable && ( scrollable.scrollHeight > scrollable.clientHeight ) )
                {
                    var atTop    = scrollable.scrollTop === 0;
                    var atBottom = Math.ceil( scrollable.scrollTop + scrollable.clientHeight ) >= scrollable.scrollHeight;

                    // Allow native vertical scrolling if not at edges
                    if ( !( e.deltaY < 0 && atTop ) && !( e.deltaY > 0 && atBottom ) )
                    {
                        return;
                    }
                }

                if ( Math.abs( e.deltaY ) > Math.abs( e.deltaX ) )
                {
                    e.preventDefault();
                    e.stopPropagation();
                    window.scrollBy( 0, e.deltaY );
                }
            },
            { passive: false, capture: true }
        );
    } );
}

function initScrollers( )
{
    var scrollerContainers = document.querySelectorAll( ".js-scroller-container" );
    scrollerContainers.forEach( scrollerContainer =>
    {
        var track = scrollerContainer.querySelector( ".js-scroller-track" );
        if ( !track ) return;
        var scrollAmount = track.dataset.scrollAmount;
        var prevButtons = scrollerContainer.querySelectorAll( ".js-scroller-prev" );
        var nextButtons = scrollerContainer.querySelectorAll( ".js-scroller-next" );

        if ( !prevButtons || !nextButtons ) return;

        prevButtons.forEach( prevButton =>
        {
            prevButton.addEventListener( "click", function( e )
            {
                //prevent extra scrolling on ios caused by scrollAmount being too high on the edges of the parent element
                if ( track.scrollLeft > scrollAmount )
                {
                    track.scrollBy({ top: 0, left: -scrollAmount, behavior: "smooth" });
                }
                else
                {
                    track.scrollBy({ top: 0, left: -track.scrollLeft, behavior: "smooth" });
                }
            });
        });

        nextButtons.forEach( nextButton =>
        {
            nextButton.addEventListener( "click", function( e )
            {
                if ( track.scrollWidth - track.scrollLeft > scrollAmount  )
                {
                    track.scrollBy({ top: 0, left: scrollAmount, behavior: "smooth" });
                }
                else
                {
                    track.scrollBy({ top: 0, left: track.scrollWidth - track.scrollLeft, behavior: "smooth" });
                }
            });
        });
    });
}

function initHeroTextSliders( )
{
    var sections = document.querySelectorAll( ".hero-text-slider" );
    sections.forEach( section =>
    {
        var slider = section.querySelector( ".js-hero-slider" );

        if ( !slider ) return;

        $( slider ).slick(
        {
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: `
            <div class="hts__slides__prev">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" class="js-hero-slider-prev">
                    <path d="M169.4 297.4C156.9 309.9 156.9 330.2 169.4 342.7L361.4 534.7C373.9 547.2 394.2 547.2 406.7 534.7C419.2 522.2 419.2 501.9 406.7 489.4L237.3 320L406.6 150.6C419.1 138.1 419.1 117.8 406.6 105.3C394.1 92.8 373.8 92.8 361.3 105.3L169.3 297.3z"/>
                </svg>
            </div>`,
            nextArrow: `
            <div class="hts__slides__next">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" class="js-hero-slider-next">
                    <path d="M471.1 297.4C483.6 309.9 483.6 330.2 471.1 342.7L279.1 534.7C266.6 547.2 246.3 547.2 233.8 534.7C221.3 522.2 221.3 501.9 233.8 489.4L403.2 320L233.9 150.6C221.4 138.1 221.4 117.8 233.9 105.3C246.4 92.8 266.7 92.8 279.2 105.3L471.2 297.3z"/>
                </svg>
            </div>`,
            draggable: true
        });
    });
}

function hideGiftPropertiesCart()
{
    var blocks = document.querySelectorAll('.cart-description');

    blocks.forEach(function(block)
    {
        var walker   = document.createTreeWalker(block, NodeFilter.SHOW_TEXT, null);
        var toRemove = [];

        while (walker.nextNode())
        {
            var node = walker.currentNode;
            var t    = (node.nodeValue || '').trim().toLowerCase();

            if (t.indexOf('_product_gift_type:free_gift') !== -1 || t.indexOf('_milestone_id:') !== -1)
            {
                toRemove.push(node);
            }
        }

        toRemove.forEach(function(n)
        {
            var previous = n.previousSibling;
            var next     = n.nextSibling;

            n.parentNode.removeChild(n);

            if (previous && previous.nodeType === 1 && previous.tagName === 'BR') { previous.remove(); }
            if (next     && next.nodeType === 1 && next.tagName === 'BR')       { next.remove(); }
        });
    });
}

function initGuestPromoCopy()
{
    document.addEventListener('click', handleGuestPromoCopyClick);
}

function handleGuestPromoCopyClick(e)
{
    var btn = e.target.closest('.guest-pill__code-btn');
    if (!btn) { return; }

    var text = btn.getAttribute('data-copy-text') || '';
    if (!text) { return; }

    var icon = btn.querySelector('.guest-pill__icon');
    if (!icon) { return; }

    try
    {
        navigator.clipboard.writeText(text);
        icon.classList.add('guest-pill__icon--copied');
        setTimeout(function()
        {
            icon.classList.remove('guest-pill__icon--copied');
        }, 1200);
    }
    catch (err)
    {
        var tmp = document.createElement('input');
        tmp.value = text;
        document.body.appendChild(tmp);
        tmp.select();
        document.execCommand('copy');
        document.body.removeChild(tmp);

        icon.classList.add('guest-pill__icon--copied');
        setTimeout(function()
        {
            icon.classList.remove('guest-pill__icon--copied');
        }, 1200);
    }
}

function initPromoSliderToggle()
{
    var bar    = document.querySelector('.promo-bar');
    if (!bar) { return; }

    var inner  = bar.querySelector('.promo-bar__inner');
    var slider = bar.querySelector('#promo-slider');
    if (!inner || !slider) { return; }

    function setPromoOpen(open)
    {
        var isOpen = (typeof open === 'boolean') ? open : !bar.classList.contains('is-open');

        if (isOpen)
        {
            bar.classList.add('is-open');
            slider.setAttribute('aria-hidden', 'false');
        }
        else
        {
            bar.classList.remove('is-open');
            slider.setAttribute('aria-hidden', 'true');
        }
    }

    var track = document.querySelector('.promo-track');
    if (track)
    {
        track.innerHTML += track.innerHTML;
    }


    function handlePromoInnerClick(e)
    {
        if (e.target && e.target.closest('a, button, summary, details, input, select, textarea')) { return; }
        if (window.matchMedia('(max-width: 768px)').matches) { setPromoOpen(); }
    }

    function handlePromoButtonClick(e)
    {
        e.stopPropagation();

        var btn = e.currentTarget;
        var expanded = btn.getAttribute('aria-expanded') === 'true';

        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        setPromoOpen(!expanded);
    }

    inner.addEventListener('click', handlePromoInnerClick);

    var buttons = bar.querySelectorAll('.promo-toggle');
    var i;
    for (i = 0; i < buttons.length; i++)
    {
        buttons[i].addEventListener('click', handlePromoButtonClick);
    }

    requestAnimationFrame(function()
    {
        bar.classList.add('promo-bar--ready');
    });
}

document.addEventListener('DOMContentLoaded', function()
{
    initGuestPromoCopy();
    initPromoSliderToggle();
});

document.addEventListener('click', function(e)
{
    var infoBtn = e.target.closest('.what-is-autoship__info');
    var titleBtn = e.target.closest('.what-is-autoship__title');
    var popover = document.querySelector('.autoship-popover');
    var overlay = document.querySelector('.overlay');
    var closeBtn = e.target.closest('.autoship-popover__close');

    if (infoBtn || titleBtn)
    {
        popover.classList.add('active');
        overlay.classList.add('active');
        return;
    }

    if (closeBtn || e.target === overlay)
    {
        popover.classList.remove('active');
        overlay.classList.remove('active');
    }
});

document.addEventListener('click', function(e)
{
    var toggle = e.target.closest('.product-row__toggle');
    if (!toggle)
    {
        return;
    }

    var wrapper = toggle.previousElementSibling;
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', !expanded);
    wrapper.classList.toggle('is-expanded', !expanded);
});

function initPromoPopovers()
{
    var popovers = document.querySelectorAll('.promo-popover-wrap');
    popovers.forEach(function(popover)
    {
        var infoButton = popover.querySelector('.promo-info');
        var content = popover.querySelector('.promo-popover');
        if (!infoButton || !content)
        {
            return;
        }
        infoButton.addEventListener('click', function(e)
        {
            if (!window.matchMedia('(hover: none)').matches)
            {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            var isActive = content.classList.toggle('active');
            document.querySelectorAll('.promo-popover.active').forEach(function(other)
            {
                if (other !== content)
                {
                    other.classList.remove('active');
                }
            });
            if (isActive)
            {
                document.addEventListener('click', handleOutsideClick);
            }
        });
        function handleOutsideClick(e)
        {
            if (!popover.contains(e.target))
            {
                content.classList.remove('active');
                document.removeEventListener('click', handleOutsideClick);
            }
        }
    });
}

function InitQuestionSideDrawer()
{
    var triggers = document.querySelectorAll('.question-side-drawer');
    var drawer = document.querySelector('.question-side-drawer__panel');
    var close = document.querySelector('.question-side-drawer__close');
    var header = document.querySelector('.header-content');
    var nav = document.querySelector('.secondary-navigation-section');
    var mobnav = document.querySelector('.sticky-nav-mob');

    if ( !triggers.length || !drawer )
    {
        return;
    }

    function openDrawer(event)
    {
        event.preventDefault();

        drawer.classList.add('active');
        document.body.style.overflow = 'hidden';

        if ( header )
        {
            header.style.zIndex = '1';
        }

        if ( nav )
        {
            nav.style.zIndex = '1';
        }

        if ( mobnav )
        {
            mobnav.style.display = 'none';
        }
    }

    function closeDrawer()
    {
        drawer.classList.remove('active');
        document.body.style.overflow = '';

        if ( header )
        {
            header.style.zIndex = '';
        }

        if ( nav )
        {
            nav.style.zIndex = '';
        }

        if ( mobnav )
        {
            mobnav.style.display = '';
        }
    }

    // open on trigger click
    triggers.forEach(function(trigger)
    {
        if ( !trigger.closest('.question-side-drawer__panel') )
        {
            trigger.addEventListener('click', openDrawer);
        }
    });

    // close button
    if ( close )
    {
        close.addEventListener('click', closeDrawer);
    }

    // close when clicking outside the drawer
    document.addEventListener('click', function(event)
    {
        var clickedInsideDrawer = drawer.contains(event.target);
        var clickedTrigger = Array.from(triggers).some(function(trigger)
        {
            return trigger.contains(event.target);
        });

        if ( drawer.classList.contains('active') && !clickedInsideDrawer && !clickedTrigger )
        {
            closeDrawer();
        }
    });

    // close on ESC key
    document.addEventListener('keydown', function(event)
    {
        if ( event.key === 'Escape' && drawer.classList.contains('active') )
        {
            closeDrawer();
        }
    });
}

document.addEventListener('DOMContentLoaded', InitQuestionSideDrawer);

function initPDPPurchaseTypeToggle( )
{
    var block = document.querySelector( ".product-row-ptt" );
    if ( block )
    {
        block.classList.remove( "hidden" );
    }
    var radios = document.querySelectorAll( ".product-row-ptt .js-ptt-input" );
    radios.forEach( radio =>
    {
        radio.addEventListener( "change", function( )
        {
            var value = radio.value;
            var buttons = document.querySelectorAll( ".js-ptt-control" );
            buttons.forEach( button =>
            {
                button.style.display = "none";
            });

            var buttonToShow = document.querySelector( ".js-ptt-control-" + value );
            if ( buttonToShow )
            {
                buttonToShow.style.display = "";
            }
        } );
    });

    var autoship = document.querySelector( ".js-ptt-control-autoship" );
    if ( autoship && radios.length > 0 )
    {
        autoship.style.display = "none";
    }
    else
    {
      autoship.classList.add( "visibility-hidden" );
    }

	var autoshipDetails      = document.querySelector( ".js-pdp-autoship-code-details" );
	var autoshipDetailsModal = document.querySelector( ".js-ptt-autoship-modal" );
	if ( autoshipDetails && autoshipDetailsModal )
	{
		autoshipDetails.addEventListener( "click", function( )
		{
			autoshipDetailsModal.classList.add( "info__code__modal--active" );
		});

		document.addEventListener( "click", function( e )
		{
			if ( !e.target.closest( ".js-ptt-autoship-modal" ) && !e.target.closest( ".js-pdp-autoship-code-details" ) )
			{
				autoshipDetailsModal.classList.remove( "info__code__modal--active" );
			}
		});
	}
}


function initCopyCodeToClipboard( )
{
	var copyButtons    = document.querySelectorAll( ".js-copy-code-clipboard" )
	var clipboardModal = document.querySelector( ".js-clipboard-modal" );
	if ( !clipboardModal )
	{
		return;
	}
	copyButtons.forEach( copyButton =>
	{
		var code = copyButton.dataset.code;
		if ( code )
		{
			copyButton.addEventListener( "click", function( )
			{
				var textEl = clipboardModal.querySelector( ".js-clipboard-modal-text" );
				if ( textEl )
				{
					var textPlaceholder = textEl.dataset.text;
					textPlaceholder = textPlaceholder.replaceAll( "%code%", code );
					navigator.clipboard.writeText( code );
					textEl.textContent = textPlaceholder;
					clipboardModal.classList.add( "clipboard-modal--active" );
					setTimeout( ( ) =>
					{
						clipboardModal.classList.remove( "clipboard-modal--active" );
					}, 5000)
				}
			});
		}
	});

	var closeModal = clipboardModal.querySelector( ".js-clipboard-modal-close" );
	closeModal.addEventListener( "click", function( )
	{
		clipboardModal.classList.remove( "clipboard-modal--active" );
	});
}

function initPDPAccordions( )
{
	var accordions = document.querySelectorAll( ".product-row-single-accordion" );

	accordions.forEach( accordion =>
	{
		var button  = accordion.querySelector( ".js-single-accordion-trigger" );
		var content = accordion.querySelector( ".js-single-accordion-content" );


		if ( button && content )
		{
			button.addEventListener( "click", function( )
			{
				if ( accordion.classList.contains( "product-row-single-accordion--active" ) )
				{
					accordion.classList.remove( "product-row-single-accordion--active" );
					content.style.maxHeight = "0";
				}

				else
				{
					accordion.classList.add( "product-row-single-accordion--active" );
					content.style.maxHeight = content.scrollHeight + "px";
				}
			});
		}
	});
}

function initPDPStickATC( )
{
    var stickyATC    = document.querySelector(".js-sticky-atc");
    var normalATC    = document.querySelector(".onetime-purchase-controls");
    var stickyNavMob = document.querySelector(".sticky-nav-mob");
    var autoshipATC  = document.querySelector(".js-ptt-control-autoship");

    if (!stickyATC || !normalATC)
    {
        return;
    }

    function hideUnselectedStickyButtonMobile()
    {
        var oneTimeQuantity  = stickyATC.querySelector(".product-quantity-col");
        var oneTimeButton    = stickyATC.querySelector(".product-buy-button-col");
        var autoshipButton   = stickyATC.querySelector(".product-buy-button-col-autoship");
        var autoshipQuantity = stickyATC.querySelector(".pdp-autoship-qty");
        var selectedRadio    = document.querySelector(".product-row-ptt .js-ptt-input:checked");
        var isAutoship       = selectedRadio && selectedRadio.value === "autoship";

        if (window.innerWidth > 768)
        {
            if (oneTimeQuantity) oneTimeQuantity.style.display   = "";
            if (oneTimeButton)   oneTimeButton.style.display     = "";
            if (autoshipButton)  autoshipButton.style.display    = "";
            if (autoshipQuantity) autoshipQuantity.style.display = "";
            return;
        }

        if (isAutoship)
        {
            if (oneTimeQuantity) oneTimeQuantity.style.display   = "none";
            if (oneTimeButton)   oneTimeButton.style.display     = "none";
            if (autoshipButton)  autoshipButton.style.display    = "";
            if (autoshipQuantity) autoshipQuantity.style.display = "";
        }
        else
        {
            if (oneTimeQuantity) oneTimeQuantity.style.display   = "";
            if (oneTimeButton)   oneTimeButton.style.display     = "";
            if (autoshipButton)  autoshipButton.style.display    = "none";
            if (autoshipQuantity) autoshipQuantity.style.display = "none";
        }
    }

    window.addEventListener("scroll", function( )
    {
        if (window.scrollY < 200)
        {
            stickyATC.classList.remove("sticky-atc-modal--active");
            if (stickyNavMob) stickyNavMob.style.display = "";
            return;
        }

        var selectedRadio = document.querySelector(".product-row-ptt .js-ptt-input:checked");
        var activeATC = normalATC;

        if (selectedRadio && selectedRadio.value === "autoship" && autoshipATC)
        {
            activeATC = autoshipATC;
        }

        var rect = activeATC.getBoundingClientRect();
        var visible = (rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight));

        if (!visible)
        {
            stickyATC.classList.add("sticky-atc-modal--active");
            if (stickyNavMob) stickyNavMob.style.display = "none";
        }
        else
        {
            stickyATC.classList.remove("sticky-atc-modal--active");
            if (stickyNavMob) stickyNavMob.style.display = "";
        }

        hideUnselectedStickyButtonMobile();
    });


    document.querySelectorAll(".js-ptt-input").forEach(function(radio)
    {
        radio.addEventListener("change", function()
        {
            hideUnselectedStickyButtonMobile();
        });
    });

    hideUnselectedStickyButtonMobile();

    var autoshipPriceEl = document.querySelector(".top__prices__autoship-price");
    var normalPriceEl   = document.querySelector(".product-main-price");
    var comparePriceEl  = document.querySelector(".product-compare-price");

    var stickyAutoBtns = stickyATC.querySelectorAll(".product-buy-button-col-autoship .autoship-add-to-cart, .sticky-autoship-trigger");

    stickyAutoBtns.forEach(function(btn)
    {
        if (!autoshipPriceEl || !normalPriceEl) return;

        var autoPriceText   = autoshipPriceEl.textContent.trim();
        var normalPriceText = normalPriceEl.textContent.trim();

        var priceHTML =
            '<span class="sticky-autoship-prices" style="display:flex; align-items:center; gap:8px; margin-left:auto;">' +
                '<span class="sticky-normal-price" style="text-decoration:line-through; opacity:0.7; font-size:13px;">' + normalPriceText + '</span>' +
                '<span class="sticky-auto-price" style="font-weight:700; font-size:15px;">' + autoPriceText + '</span>' +
            '</span>';

        if (!btn.querySelector(".sticky-autoship-prices"))
        {
            btn.insertAdjacentHTML("beforeend", priceHTML);
        }
    });

    var stickyOneBtns = stickyATC.querySelectorAll(".product-buy-button-col .product-form__submit");

    stickyOneBtns.forEach(function(btn)
    {
        if (!normalPriceEl) return;

        var normalPriceText  = normalPriceEl.textContent.trim();
        var comparePriceText = comparePriceEl ? comparePriceEl.textContent.trim() : null;

        var priceHTML =
            '<span class="sticky-onetime-prices" style="display:flex; align-items:center; gap:8px; margin-left:auto;">' +
                (comparePriceText ? '<span class="sticky-compare" style="text-decoration:line-through; opacity:0.7; font-size:13px;">' + comparePriceText + '</span>' : '') +
                '<span class="sticky-onetime-price" style="font-weight:700; font-size:15px;">' + normalPriceText + '</span>' +
            '</span>';

        if (!btn.querySelector(".sticky-onetime-prices"))
        {
            btn.insertAdjacentHTML("beforeend", priceHTML);
        }
    });
}




document.addEventListener("click", function(e)
{
    var trigger = e.target.closest(".sticky-autoship-trigger");
    if (!trigger)
    {
        return;
    }

    trigger.querySelector( "svg" ).classList.add( "autoship-icon--rotating" );

    var realButton = document.querySelector(".autoship-add-to-cart");

    if (realButton)
    {
        realButton.click();
    }
});

document.addEventListener('click', function(e)
{
    var pop = document.querySelector('.js-onetime-popover');
    if ( pop )
    {
        var overlay = document.querySelector('.overlay');

        var isOpen = pop.classList.contains('active');

        if (e.target.closest('.js-pdp-onetime-code-details'))
        {
            pop.classList.add('active');
            overlay.classList.add('active');
            return;
        }

        if (e.target.closest('.js-onetime-close'))
        {
            pop.classList.remove('active');
            overlay.classList.remove('active');
            return;
        }

        if (e.target.closest('.overlay'))
        {
            pop.classList.remove('active');
            overlay.classList.remove('active');
            return;
        }

        if (isOpen && !e.target.closest('.js-onetime-popover'))
        {
            pop.classList.remove('active');
            overlay.classList.remove('active');
            return;
        }
    }
});


function setupPttPriceSwitcher()
{
    var pttInputs = document.querySelectorAll('.js-ptt-input');

    if (!pttInputs || pttInputs.length === 0)
    {
        return;
    }

    var mainPriceEl = document.querySelector('.product-main-price');
    var discountEl = document.querySelector('.product-discount-percentage');
    var compareEl = document.querySelector('.product-compare-price');
    
    // Store the initial price immediately, before any modifications
    // This ensures we capture the correct regular price even for autoship members
    var initialMainPrice = mainPriceEl ? mainPriceEl.textContent.trim() : null;
    
    // Get the normal price from multiple sources, prioritizing the most reliable
    // 1. Try .top__prices__curr-price (regular price shown in purchase type toggle)
    // 2. Try .top__price (one-time purchase price in the toggle)  
    // 3. Use the initial main price we captured (before any JS modifications)
    var currPriceEl = document.querySelector('.top__prices__curr-price');
    var onetimePriceEl = document.querySelector('.ptt__onetime .top__price');
    var normalPrice = null;
    
    if (currPriceEl && currPriceEl.textContent.trim())
    {
        normalPrice = currPriceEl.textContent.trim();
    }
    else if (onetimePriceEl && onetimePriceEl.textContent.trim())
    {
        normalPrice = onetimePriceEl.textContent.trim();
    }
    else if (initialMainPrice)
    {
        // Use the initial price captured before any modifications
        // This handles cases where .top__prices__curr-price doesn't exist (autoship members)
        normalPrice = initialMainPrice;
    }
    
    var normalDiscount = discountEl ? discountEl.textContent.trim() : null;
    
    // Check initial state - if autoship is already selected, set price immediately
    var initialCheckedValue = null;
    for (var j = 0; j < pttInputs.length; j++)
    {
        if (pttInputs[j].checked)
        {
            initialCheckedValue = pttInputs[j].value;
            break;
        }
    }
    
    // Function to check if user has active autoship (check dynamically)
    function hasActiveAutoship()
    {
        return document.body.classList.contains('has-autoship');
    }
    
    // Function to set initial price based on autoship status
    function setInitialPrice()
    {
        if (!mainPriceEl || !normalPrice) return;
        
        // Check current state, not just initial state (in case autoship was programmatically selected)
        var currentCheckedValue = null;
        for (var k = 0; k < pttInputs.length; k++)
        {
            if (pttInputs[k].checked)
            {
                currentCheckedValue = pttInputs[k].value;
                break;
            }
        }
        
        if (hasActiveAutoship())
        {
            // Active autoship users: always show regular product price
            mainPriceEl.textContent = normalPrice;
        }
        else if (currentCheckedValue === 'autoship')
        {
            // Non-autoship users with autoship selected: show autoship price
            var initialRow = pttInputs[0].closest('.product-row');
            if (initialRow)
            {
                var initialAutoshipPriceEl = initialRow.querySelector('.top__prices__autoship-price');
                if (initialAutoshipPriceEl && initialAutoshipPriceEl.textContent.trim())
                {
                    var autoshipPriceText = initialAutoshipPriceEl.textContent.trim();
                    // Only update if we have a valid autoship price
                    if (autoshipPriceText && autoshipPriceText !== mainPriceEl.textContent.trim())
                    {
                        mainPriceEl.textContent = autoshipPriceText;
                    }
                }
                // Don't fall back to normalPrice if autoship is selected - wait for element to be ready
            }
        }
        else
        {
            // One-time selected or no selection
            mainPriceEl.textContent = normalPrice;
        }
    }
    
    // Set initial price - check multiple times in case has-autoship class is added asynchronously
    // or autoship button is clicked programmatically
    setInitialPrice();
    setTimeout(setInitialPrice, 100);
    setTimeout(setInitialPrice, 500);
    setTimeout(setInitialPrice, 1000);
    setTimeout(setInitialPrice, 2000); // Extra delay for programmatic autoship selection
    
    // Watch for when autoship radio button becomes checked (for programmatic selection)
    if (pttInputs.length > 0)
    {
        var autoshipInput = null;
        for (var m = 0; m < pttInputs.length; m++)
        {
            if (pttInputs[m].value === 'autoship')
            {
                autoshipInput = pttInputs[m];
                break;
            }
        }
        
        if (autoshipInput)
        {
            // Watch for when autoship becomes checked
            var checkObserver = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'checked')
                    {
                        if (autoshipInput.checked && !hasActiveAutoship())
                        {
                            // Autoship was just checked for non-autoship user, update price
                            setTimeout(setInitialPrice, 50);
                        }
                    }
                });
            });
            
            checkObserver.observe(autoshipInput, { attributes: true, attributeFilter: ['checked'] });
        }
    }
    
    // Watch for has-autoship class being added
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                // Only update if class was added (not removed)
                if (hasActiveAutoship() && mainPriceEl && normalPrice)
                {
                    // If autoship class was just added, ensure price is set to regular price
                    mainPriceEl.textContent = normalPrice;
                }
                else if (!hasActiveAutoship())
                {
                    // If class was removed, re-check the current selection
                    setInitialPrice();
                }
            }
        });
    });
    
    if (document.body)
    {
        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }

    for (var i = 0; i < pttInputs.length; i++)
    {
        var input = pttInputs[i];

        input.addEventListener('change', function ()
        {
            var row = this.closest('.product-row');

            if (!row)
            {
                return;
            }

            if (this.value === 'autoship')
            {
                var autoshipPriceEl = row.querySelector('.top__prices__autoship-price');

                // Only update main price for non-autoship users
                // Active autoship users: main price always stays as regular product price
                // Check dynamically each time in case class is added/removed
                if (!hasActiveAutoship() && autoshipPriceEl && mainPriceEl)
                {
                    var autoshipPrice = autoshipPriceEl.textContent.trim();
                    if (autoshipPrice)
                    {
                        mainPriceEl.textContent = autoshipPrice;
                    }
                }
                else if (hasActiveAutoship() && mainPriceEl && normalPrice)
                {
                    // Ensure autoship users always see regular price
                    mainPriceEl.textContent = normalPrice;
                }

                // Update discount percentage if needed
                if (discountEl && compareEl && autoshipPriceEl)
                {
                    var compareAt = parseFloat(compareEl.textContent.replace(/[^0-9.]/g, ''));
                    var autoPrice = parseFloat(autoshipPriceEl.textContent.replace(/[^0-9.]/g, ''));

                    if (!isNaN(compareAt) && compareAt > 0)
                    {
                        var percent = Math.round(((compareAt - autoPrice) / compareAt) * 100);
                        discountEl.textContent = '- ' + percent + '%';
                    }
                }
            }
            else
            {
                if (mainPriceEl)
                {
                    // When switching to one-time, use the normal price
                    mainPriceEl.textContent = normalPrice;
                }

                if (discountEl)
                {
                    discountEl.textContent = normalDiscount;
                }
            }
        });
    }
}

function DisableMembershipCTA()
{
    var cta = document.querySelector('.membership-cta');

    if (!cta)
    {
        return;
    }

    cta.addEventListener('click', function(event)
    {
        cta.classList.add('disabled');
    });
}

document.addEventListener("DOMContentLoaded", function()
{
    SetupOrdersListScrollFix();
    SetupManageOrderLink();
    flipWECWidgetLink();
    populateWellEasyCash();
    initAutoshipNextOrderWidgets();
    initSecondaryNav();
    handleCustomLoyaltyContent();
    initScrollers( );
    initHeroTextSliders( );
    initWelleasyCashNoFlicker();
    initPromoPopovers();
    initPDPAccordions( );
    initCopyCodeToClipboard( );
    initPDPStickATC( );
    setupPttPriceSwitcher();
    DisableMembershipCTA();
    
    // mw 20251020: removed. wtf ??
    //setTimeout(hideGiftPropertiesCart, 1500);
});
